import type { DriftEntry } from '../api/types';
import { actionPresentation } from '../components/presentation';
import { StatusBadge } from '../components/ui';
import { strings } from '../strings';

function ChangedProperties({ properties }: { properties: string[] }) {
  if (properties.length === 0) return <>{strings.common.dash}</>;
  return (
    <details>
      <summary className="cursor-pointer text-sm">{strings.runs.showProperties(properties.length)}</summary>
      <ul className="mt-1 list-inside list-disc font-mono text-xs">
        {properties.map((property) => (
          <li key={property}>{property}</li>
        ))}
      </ul>
    </details>
  );
}

export function DriftView({ drift }: { drift: DriftEntry[] }) {
  const drifted = drift.filter((entry) => entry.change !== 'no-change');
  if (drifted.length === 0) return <p className="help">{strings.runs.noDrift}</p>;
  return (
    <table className="table">
      <thead>
        <tr>
          <th scope="col">{strings.runs.action}</th>
          <th scope="col">{strings.runs.resource}</th>
          <th scope="col">{strings.runs.changedProperties}</th>
        </tr>
      </thead>
      <tbody>
        {drifted.map((entry) => (
          <tr key={entry.resourceId}>
            <td>
              <StatusBadge presentation={actionPresentation[entry.change]} />
            </td>
            <td className="font-mono">{entry.resourceId}</td>
            <td>
              <ChangedProperties properties={entry.changedProperties} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
